package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable


@Serializable
data class Stage(
    val post: String,
    val enterprise: String,
    val city: String,
    val started: String,
    val ended: String,
    val description: String,
)